import { ChainGrpcCommonTransformer } from './ChainGrpcCommonTransformer.js';
/**
 * @category Chain Grpc Transformer
 */
export class ChainGrpcErc20Transformer {
    static grpcTokenPairToTokenPair(grpcTokenPair) {
        return {
            bankDenom: grpcTokenPair.bankDenom,
            erc20Address: grpcTokenPair.erc20Address,
        };
    }
    static paramsResponseToParams(response) {
        const params = response.params;
        return {
            denomCreationFee: params?.denomCreationFee,
        };
    }
    static tokenPairsResponseToTokenPairs(response) {
        return {
            tokenPairs: response.tokenPairs.map((tokenPair) => ({
                bankDenom: tokenPair.bankDenom,
                erc20Address: tokenPair.erc20Address,
            })),
            pagination: ChainGrpcCommonTransformer.grpcPaginationToPagination(response.pagination),
        };
    }
}
